export enum ReviewEntryStatus {
  Parsed = 'parsed',
  Validated = 'validated',
  Written = 'written',
}
